<template>
    <div id="WebChatVisibility">
        <div class="tab-visibility" v-if="channel">
            <div class="header">
                <div class="title">{{ $t("mail_integration_detail.visibility") }}</div>
                <div class="subtitle">{{ $t("whatsapp_business_api.manageWhoChannelChat") }}</div>
            </div>

            <VisibilityChanger v-model="clone.visibility" :show-title="false" />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import VisibilityChanger from "../../../WhatsappV1/VisibilityChanger.vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import log2 from "../../../../../utils/log2";

const log = log2("WebChatVisibility.vue");
export default Vue.extend({
    name: "WebChatVisibility",
    components: { VisibilityChanger },
    data() {
        return {
            channel: null,
            clone: null,
            loading: false,
        };
    },
    computed: {
        ...mapState({
            webChatChannel: (state) => state.channel.channels.find((channel) => channel.type === "webchat"),
        }),
    },
    mounted() {
        this.channel = this.webChatChannel;
        if (this.channel) {
            this.clone = _.cloneDeep(this.channel);
        }
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
        }),
        handleSave() {
            this.loading = true;
            this.updateChannel(this.clone)
                .then(() => {
                    this.listChannels();
                    this.$message.success("WebChat visibility updated successfully.");
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error("Failed to update WebChat visibility.");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    watch: {
        clone: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.channel);
                    if (isChanged) {
                        log("clone changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        webChatChannel: {
            handler: function (val) {
                this.channel = val;
                if (val) {
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>
<style lang="scss" scoped>
#WebChatVisibility {
    .tab-visibility {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 20px;

        .header {
            display: flex;
            justify-content: space-between;
            padding-bottom: 10px;
            border-bottom: 1px solid var(--color-border-default);

            .title {
                font-size: 18px;
                font-weight: 700;
                color: var(--color-text-strong-default);
            }

            .subtitle {
                font-size: 14px;
                color: var(--color-text-strong-default);
            }
        }
    }
}
</style>
